module.exports = __webpack_public_path__ + "assets/img/SUSS.2a543e93.jpg";